/**
 * Static wall entity — isometric wall segments at the room perimeter.
 * Layer 0 with a depth offset so walls sort correctly against floor tiles.
 */

import type { Sprite } from "../sprites/SpriteSheet.js";
import { Entity } from "./Entity.js";
import { depthKey } from "../engine/IsoMath.js";

export class WallEntity extends Entity {
  private sprite: Sprite;

  constructor(id: string, col: number, row: number, sprite: Sprite) {
    super(id, col, row, 0);
    this.sprite = sprite;
    // Bump depth slightly so walls draw in front of floor tiles at same position
    // but behind furniture/characters at same grid cell
    this.depth = depthKey(col, row, 0) + 50;
  }

  update(_dt: number): void {
    // Static
  }

  draw(ctx: CanvasRenderingContext2D): void {
    const frame = this.sprite.frames[0];
    ctx.drawImage(
      frame,
      this.worldX - this.sprite.originX,
      this.worldY - this.sprite.originY,
    );
  }
}
